<template>
  <div class="sky-hc-software-list sky-hc-software-list__no-border">
    <div class="sky-hc-software-list__head">
      <div class="sky-hc-software-list__head-right">
        <el-button icon="el-icon-plus" @click.native="handleAddSoftware">{{
          $t('software.addSoftwareDictionary')
        }}</el-button>
        <!-- <el-button icon="el-icon-share" @click.native="syncToTerminal">{{$t('software.syncToTerminal')}}</el-button> -->
      </div>
    </div>
    <pagination-table
      ref="multipleTable"
      :data="dataList"
      :limit="limit"
      :total="count"
      :hasSearch="true"
      :page="page"
      :searchPlaceholder="$t('software.softwareListSeach')"
      @search="handleSearchContent"
      @prevClick="handlePrevClick"
      @nextClick="handleNextClick"
      @sizeChange="handleSizeChange"
    >
      <template slot="columns">
        <el-table-column prop="name" :label="$t('software.softwareName')"></el-table-column>
        <el-table-column prop="matchType" :label="$t('software.matchType')" width="260"> </el-table-column>
        <el-table-column prop="createTime" :label="$t('software.createTime')" width="260">
          <template slot-scope="scope">
            {{ scope.row.createTime ? date.format(scope.row.createTime, 'yyyy-MM-dd HH:mm:ss') : '' }}
          </template></el-table-column
        >
        <el-table-column :label="$t('articleManage.handler')" width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span class="sky-hc-software-list__table-btn" @click="handleDelSoftware(scope.row.id)">{{
              $t('software.del')
            }}</span>
          </template>
        </el-table-column>
      </template>
    </pagination-table>
    <AddSoftwareDialog v-if="showSoftwareDialog" @close="closeSoftwareDialog" @success="handleAddSuccess" />
  </div>
</template>
<script>
import { TableColumn, Input, Button, Select, Option } from 'element-ui'

import date from 'element-ui/lib/utils/date'

import AddSoftwareDialog from './components/addSoftwareDialog'

import { getSoftwareDictionary, deleteSoftwareDict, synchGlobalSoftwareDict } from '@/api/terminal'
import PaginationTable from '@/components/paginationTable'

export default {
  name: 'ContentAnalysis',
  components: {
    PaginationTable,
    [TableColumn.name]: TableColumn,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    AddSoftwareDialog
  },
  data() {
    return {
      date,
      showSoftwareDialog: false,
      limit: 20,
      count: 0,
      page: 0,
      keyword: '',
      dataList: [],
      loading: false
    }
  },
  created() {
    this.handleGetSoftwareDictionary()
  },
  methods: {
    handleSearchContent(keyword) {
      this.keyword = keyword
      this.handleGetSoftwareDictionary()
    },
    handlePrevClick() {
      this.page--
      this.handleGetSoftwareDictionary()
    },
    handleNextClick() {
      this.page++
      this.handleGetSoftwareDictionary()
    },
    handleSizeChange(num) {
      this.limit = num
      this.page = 0
      this.handleGetSoftwareDictionary()
    },
    handleGetSoftwareDictionary() {
      getSoftwareDictionary({
        page: this.page,
        limit: this.limit,
        searchKeyword: this.keyword
      }).then(response => {
        this.dataList = response.data.content.itemArr
        this.count = response.data.content.total
      })
    },
    handleAddSoftware() {
      this.showSoftwareDialog = true
    },
    closeSoftwareDialog() {
      this.showSoftwareDialog = false
    },
    // 删除软件字典
    handleDelSoftware(id) {
      if (this.loading) return
      this.loading = true
      deleteSoftwareDict({
        idArr: [id]
      })
        .then(() => {
          this.dataList = this.dataList.filter(item => {
            return item.id !== id
          })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 软件字典添加成功
    handleAddSuccess() {
      this.closeSoftwareDialog()
      this.page = 0
      this.handleGetSoftwareDictionary()
    },
    // 同步至终端
    syncToTerminal() {
      if (this.loading) return
      this.loading = true
      synchGlobalSoftwareDict()
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss">
@import '~sky-engine/assets/styles/common/var.scss';
@import '~sky-engine/assets/styles/mixin/mixin.scss';
@include b(hc-software-list) {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  box-shadow: none;
  @include e(head) {
    display: flex;
    // justify-content: flex-end;
    margin-bottom: 22px;
  }
  @include e(table-btn) {
    color: $--color-primary;
    cursor: pointer;
    @include m(mr18) {
      margin-right: 18px;
    }
  }
}
</style>
